import {
  DELETE_TRANSLATION_KEY,
  GET_TRANSLATIONS,
  GET_TRANSLATIONS_BY_NAME,
  UPSERT_PRIMARY_TRANSLATION,
  UPSERT_TRANSLATION,
  UPSERT_TRANSLATIONS,
} from '../types';
import { createAxiosAction } from '../utils';

export default {
  deleteTranslationKey: id => {
    return createAxiosAction({
      url: '/api/v1/translations',
      method: 'DELETE',
      body: { id },
      startAction: DELETE_TRANSLATION_KEY,
    });
  },
  getTranslations: (projectId, languageId, namespaceId) => {
    return createAxiosAction({
      url: `/api/v1/projects/${projectId}/languages/${languageId}/namespaces/${namespaceId}/translations`,
      startAction: GET_TRANSLATIONS,
    });
  },
  getTranslationsByNames: (projectName, namespaceName, translationKey) => {
    return createAxiosAction({
      url: `/api/v1/projects/${projectName}/namespaces/${namespaceName}/translations/${translationKey}`,
      startAction: GET_TRANSLATIONS_BY_NAME,
    });
  },
  upsertPrimaryTranslation: (namespaceId, languageId, keyName, value) => {
    return createAxiosAction({
      url: '/api/v1/translations/primary',
      body: { namespaceId, languageId, keyName, value },
      method: 'POST',
      startAction: UPSERT_PRIMARY_TRANSLATION,
    });
  },
  upsertTranslation: (namespaceId, languageId, translationKeyId, value) => {
    return createAxiosAction({
      url: '/api/v1/translations',
      body: { namespaceId, languageId, translationKeyId, value },
      method: 'POST',
      startAction: UPSERT_TRANSLATION,
    });
  },
  upsertTranslations: (namespaceId, translationKeyId, translations) => {
    return createAxiosAction({
      url: '/api/v1/translations',
      body: { namespaceId, translationKeyId, translations },
      method: 'POST',
      startAction: UPSERT_TRANSLATIONS,
    });
  },
};
